import { render, staticRenderFns } from "./EliotTreeMenu.vue?vue&type=template&id=636680d9"
import script from "./EliotTreeMenu.vue?vue&type=script&lang=ts"
export * from "./EliotTreeMenu.vue?vue&type=script&lang=ts"
import style0 from "./EliotTreeMenu.vue?vue&type=style&index=0&id=636680d9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports